import { useEffect, useMemo } from "react"
import { useApolloClient } from "@apollo/client"

import { useAppSelector, useAppDispatch } from '../../../Store'
import { gqlActions } from "../gqlData_Reducer"

/* eslint-disable */
import { USER_LOGIN, LoginResponse, LoginArgs, Farms_Data, User_Data, USER_INFO, UserInfoResponse, UPDATE_USER_INFO, UpdateUserInfoArgs, UpdateUserInfoResponse, Farm_Data, FarmInfoResponse, FARM_INFO, UpdateFarmInfoArgs, UPDATE_FARM_INFO, FarmInfoArgs, UpdateFarmInfoResponse, Def_MutationResponse, CreateUserResponse, CREATE_USER, CreateArgs } from "./GQLCalls/getCalls"
import { USER_FARMS, FarmsResponse, UserFarmsArgs, UserInfoArgs } from "./GQLCalls/getCalls"

import { UserStates, UserActions } from "./UserSlices/userSlice"
import { PersistPartial } from "redux-persist/lib/persistReducer";
import { CREATE_RESET_PASSWORD_ENTRY, CreateResetResponse, TOKEN_RESET_PASSWORD, TokenResetPassword, TokenResetResponse } from "./GQLCalls/createCalls"
/* eslint-enable */

export type UseUser = {
  doLogin:(username:string, password:string) => Promise<boolean>,
  doLogOut:() => void,
  createNewUser:(username: string, password: string, firstname:string, lastname:string, email:string, phone:string)=>void,
  createUserResetToken: (username: string) => Promise<boolean>;
  tokenResetPassword: (token: string, password:string) => Promise<boolean>;
  getUserFarms:()=>void
  getUserData:(jwt?:string)=>void,
  updateUserData:(firstname:string,lastname:string,phone:string,email:string,address:string,country:string, jwt?:string)=>void,
  getFarmData:(domain:string)=>void,
  updateFarmData:(name:string, city:string,street:string,phone:string,vat:string,email:string,domain?:string)=>void,
  data: UserStates & PersistPartial,
  userToken?: string,
  userFarms?: Farms_Data[],
  userData?: User_Data
  farmData?: Farm_Data[]
} 

export const useUser = (userToken?:string):UseUser => {
  const dispatch = useAppDispatch()
  const client = useApolloClient()

  const UserStates = useAppSelector(({graphQlData:{user}}) => user)
  const {fullState, UserToken, UserFarms, UserData, FarmData} = useMemo(() => {
    //TODO: UserStates.UserInfo is not array....
    var info = (UserStates.UserInfo as unknown) as any
    return {
      fullState: UserStates, 
      UserToken: UserStates.UserToken, 
      UserFarms: UserStates.UserFarms,
      UserData: info&&info[0]?info[0]:undefined,
      FarmData: UserStates.FarmInfo,
    }
  }, [UserStates])
  
  useEffect(() => {
    if (userToken) {
      getUserFarms()
    }
  }, []) // ??? UserToken

  const getUserFarms = async (farm_id?:number) => {
    if (UserToken) {
      await client.query<FarmsResponse>({query:USER_FARMS, variables:{farm_id} as UserFarmsArgs}).then(e => {
        if (e && e.data && e.data.getUserFarms) {
          var FarmsData = e.data.getUserFarms
          if (FarmsData && FarmsData.length) {
            dispatch({type:''+gqlActions.user.setUserFarms, payload:FarmsData})
          }
        }
      })
    }
  }

  const getUserData = async (jwt?:string) => {
    if (UserToken) {
      await client.query<UserInfoResponse>({query:USER_INFO, variables:{jwt:jwt?jwt:UserToken} as UserInfoArgs, fetchPolicy:"no-cache"}).then(e => {
        if (e && e.data && e.data.getUserInfo) {
          //TODO: is not array.... ???
          var UserData = e.data.getUserInfo
          if (UserData) { 
            dispatch({type:''+gqlActions.user.setUserData, payload:UserData})
          }
        }
      })
    }
  }
  const updateUserData = async (firstname:string,lastname:string,phone:string,email:string,address:string,country:string, jwt?:string) => {
    if (UserToken) {
      await client.mutate<UpdateUserInfoResponse>({mutation:UPDATE_USER_INFO, variables:{firstname, lastname, phone, email, address, country, jwt:jwt?jwt:UserToken} as UpdateUserInfoArgs}).then(e => {
        if (e && e.data && e.data.updateUserInfo) {
          //TODO: is not array.... ???
          var UserData = e.data.updateUserInfo
          if (UserData && UserData.success) {
            dispatch({type:''+gqlActions.user.setUserData, payload:{firstname, lastname, phone, email, address, country} as User_Data})
          }
        }
      })
    }
  }

  const getFarmData = async (domain:string) => {
    if (UserToken) {
      await client.query<FarmInfoResponse>({query:FARM_INFO, variables:{domain} as FarmInfoArgs}).then(e => {
        if (e && e.data && e.data.getFarmInfo) {
          //TODO: is not array.... ???
          var FarmData = e.data.getFarmInfo
          if (FarmData) { 
            dispatch({type:''+gqlActions.user.setFarmData, payload:FarmData})
          }
        }
      })
    }
  }
  const updateFarmData = async (name:string, city:string,street:string,phone:string,vat:string,email:string, domain?:string) => {
   
      await client.mutate<UpdateFarmInfoResponse>({mutation:UPDATE_FARM_INFO, variables:{city, street, phone, vat, email,domain} as UpdateFarmInfoArgs}).then(e => {
        if (e && e.data && e.data.updateFarmInfo) {
          //TODO: is not array.... ???
          var FarmData = e.data.updateFarmInfo
          if (FarmData && FarmData.success) {
            dispatch({type:''+gqlActions.user.setFarmData, payload:[{ name, city, street, phone, vat, email, domain }] as Farm_Data[]})
          }
        }
      })
    
  }

  const doLogin = async (username:string, password:string):Promise<boolean> => {
    return await client.query<LoginResponse>({query:USER_LOGIN, variables:{username, password} as LoginArgs}).then(e => {
      if (e && e.data && e.data.login) {
        const loginData = e.data.login
        if (loginData.code + '' === "200" && loginData.message) {
          dispatch({type:''+gqlActions.user.setUserToken, payload:loginData.message})
          getUserFarms()
          return true
        }
      }
      return false
    })
  }
  const doLogOut = () => {
    if (UserToken) {
      dispatch({type:''+gqlActions.user.clear, payload:'all'}) //TODO: get actual type
    }
  }
  
  const createNewUser = async (username: string, password: string, firstname:string, lastname:string, email:string, phone:string) => {
    await client.query<CreateUserResponse>({query:CREATE_USER, variables:{username, password, firstname, lastname, email, phone} as CreateArgs}).then(e => {
      if (e && e.data && e.data.createUser) {
        const createData = e.data.createUser
        if (createData && createData.success) {
          dispatch({type:''+gqlActions.user.setUserData, payload: {username, password, firstname, lastname, email, phone} as CreateArgs})
        }
      }
    })
  }

  const createUserResetToken = async (username: string):Promise<boolean> => {
    return await client.mutate<CreateResetResponse>({mutation: CREATE_RESET_PASSWORD_ENTRY, variables: {username}}).then(e => {
      if (e && e.data && e.data.createResetPasswordEntry) {
        return e.data.createResetPasswordEntry.success;
      }
      return false
    })
  }

  const tokenResetPassword = async (token: string, password: string) => {
    return await client.mutate<TokenResetResponse>({mutation: TOKEN_RESET_PASSWORD, variables: {token, password}}).then(e => {
      if (e && e.data && e.data.tokenResetPassword) {
        return e.data.tokenResetPassword.success;
      }
      else return false
    })
  }
  
  return { doLogin, doLogOut, createNewUser, data:fullState, getUserFarms, userToken:UserToken, userFarms:UserFarms, getUserData, userData:UserData, updateUserData, getFarmData, farmData:FarmData, updateFarmData, createUserResetToken, tokenResetPassword}
}